export const currentRecurrentExpense = (state) => state.currentRecurrentExpense
